import { QueryHookOptions } from '@apollo/client'
import B2C_GET_COMPLETED_ORDERS from '@graphql/queries/getCompletedOrders.query'
import { B2CGetCompletedOrdersQuery, B2CGetCompletedOrdersQueryVariables } from 'parkdepot-shared/gql/graphql'
import { useAuthenticatedQuery } from './useAuth'

const useGetCompletedOrders = (
    opts: QueryHookOptions<B2CGetCompletedOrdersQuery, B2CGetCompletedOrdersQueryVariables>
) => {
    return useAuthenticatedQuery({ query: B2C_GET_COMPLETED_ORDERS, ...opts })
}

export default useGetCompletedOrders
